import { render, staticRenderFns } from "./leaderBoard.vue?vue&type=template&id=765e6e66&scoped=true"
import script from "./leaderBoard.vue?vue&type=script&lang=js"
export * from "./leaderBoard.vue?vue&type=script&lang=js"
import style0 from "./leaderBoard.vue?vue&type=style&index=0&id=765e6e66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e6e66",
  null
  
)

export default component.exports